export const getEnvConfig = () => ({
  EVERVAULT: {
    APP_ID: import.meta.env.VITE_EVERVAULT_APP_ID,
    TEAM_ID: import.meta.env.VITE_EVERVAULT_TEAM_ID,
  },
  SENTRY: {
    DSN: import.meta.env.VITE_SENTRY_DSN,
    ENV: import.meta.env.VITE_SENTRY_ENV,
  },
  SUPPORT: {
    TELEPHONE: import.meta.env.VITE_SUPPORT_TELEPHONE,
  },
  LOQATE: {
    ENABLED: import.meta.env.VITE_ENABLE_LOQATE?.toLowerCase() !== "false",
    SERVER: import.meta.env.VITE_LOQATE_SERVER,
    KEY: import.meta.env.VITE_LOQATE_KEY,
  },
  APP: {
    GLOBAL_MESSAGE: import.meta.env.VITE_GLOBAL_MESSAGE,
    INACTIVITY_TIMEOUT_MINUTES: import.meta.env.VITE_INACTIVITY_TIMEOUT_MINUTES
      ? Number(import.meta.env.VITE_INACTIVITY_TIMEOUT_MINUTES)
      : 0,
    SUPPORTED_LANGUAGES:
      import.meta.env.VITE_SUPPORTED_LANGUAGES?.split(",").map((code: string) =>
        code.trim()
      ) ?? [],
  },
  NMIBLE: {
    SERVER_V3: import.meta.env.VITE_NMIBLE_SERVER_V3,
  },
});

export const ENV = getEnvConfig();

export type SupportedLanguage = (typeof ENV.APP.SUPPORTED_LANGUAGES)[number];
